import React from 'react';
import { ToastContainer } from 'react-toastify';
import RouterData from './Routes/AppRouter';
import 'react-toastify/dist/ReactToastify.css';

/**
 * Composant principal de l'application Docarn
 */
function App() {
  return (
    <>
      <RouterData />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}

export default App;
